<template>
    <div v-if="contact" class="card mx-1">
        <div class="card-body">
            <div class="user-profile-view">
                <div class="profile-header">
                    <div class="profile-image-container mb-3">
                        <img :src="contact?.image || '/img/images/profile_image_placeholder.png'" class="profile-image"
                            alt="Contact Avatar">
                    </div>
                    <div class="profile-info">
                        <h3 class="mb-0">{{ contact?.first_name || '' }} {{ (contact?.last_name) ?
                            contact.last_name.substring(0, 1).toUpperCase() + '.' : '' }}</h3>
                        <p class="mb-0">Lockstep {{ contact_type }}</p>
                        <small class="text-muted" v-if="contact_type === 'Specialist'">Trains, sets up, and ensures you
                            are setup in Avid. This is your start
                            line.</small>
                        <small class="text-muted" v-if="contact_type === 'Expert'">Helps you align Avid with your goals,
                            to use the platform effectively.</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer text-end">
            <button class="btn btn-primary lockstep-button" @click="sendEmail">
                <!-- <img src="/img/icons/avid-icons/email.svg" class="icon" alt="">  -->
                Send Email
            </button>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useLockstepStore } from '../../stores/lockstep'
import Button from '../components/Button.vue'

export default defineComponent({
    name: 'Contact',
    props: {
        contact: {
            type: Object,
            required: false,
            default: null
        },
        type: {
            type: String,
            required: true
        }
    },
    components: {
        Button
    },
    mounted() {
        // console.log('Contact component mounted with contact:', this.contact);
        // console.log('Contact type:', this.type);
    },
    data() {
        return {
            lockstepStore: useLockstepStore()
        }
    },
    computed: {
        contact_type() {
            if (this.type === 'specialist') {
                return 'Specialist'
            } else {
                return 'Expert'
            }
        }
    },
    methods: {
        sendEmail() {
            if (this.contact?.email) {
                window.open(`mailto:${this.contact.email}`, '_blank');
            }
        },
    }
})
</script>
